// extracted by mini-css-extract-plugin
export default {"badgeTitle":"L8ewMEvW__seFSWCB2pR"};